import React from 'react';

function ReportIcon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#e8eaed" viewBox="0 -960 960 960">
      <path
        fill={props.fill || '#EF3C34'}
        d="M480-291.54q13.73 0 23.02-9.29t9.29-23.02q0-13.73-9.29-23.02-9.29-9.28-23.02-9.28t-23.02 9.28q-9.29 9.29-9.29 23.02t9.29 23.02q9.29 9.29 23.02 9.29zm-30-139.23h60v-241.54h-60v241.54zM338.46-140L140-338.28v-283.26L338.28-820h283.26L820-621.72v283.26L621.72-140H338.46zM364-200h232l164-164v-232L596-760H364L200-596v232l164 164zm116-280z"
      ></path>
    </svg>
  );
}

export default ReportIcon;
